import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './components/Home.vue';
import Login from './components/Login.vue';
import Policy from './components/Policy.vue';

const routes = [
    { path: '/', component: Home },
    { path: '/login', component: Login, name: 'login' },
    { path: '/sham-express', component: Policy, name: 'policy'}
];

const keyAdwaa = 'kaxtusinmymind777';

Vue.use(VueRouter);


const router = new VueRouter({routes});
router.beforeEach((to, from, next) => {
   // if(to.name === 'login')
    next();
});


export default router;
